export interface DemandFormData {
  full_name: string;
  email: string;
  company: string;
  phone: string;
  segment: string;
  stores: string;
  skus: string;
  sales_history: string;
  stock_control: string;
  difficulty: string;
  consent_accepted: boolean;
}

export type DemandFormField = keyof DemandFormData;

export type DemandFormErrors = Partial<Record<DemandFormField, string>>;

export type DemandRequestState = 'idle' | 'loading' | 'success' | 'error';

export interface DemandSuccessResponse {
  success: true;
}

export interface DemandErrorResponse {
  success: false;
  code: string;
  message?: string;
  fieldErrors?: DemandFormErrors;
}

export type DemandApiResponse = DemandSuccessResponse | DemandErrorResponse;

export interface SelectOption {
  value: string;
  label: string;
}

export const DIFFICULTY_MAX_LENGTH = 1000;

export const SEGMENT_OPTIONS: SelectOption[] = [
  { value: 'varejo', label: 'Varejo' },
  { value: 'distribuicao', label: 'Distribuição / Atacado' },
  { value: 'industria', label: 'Indústria / Fabricação' },
  { value: 'ecommerce', label: 'E-commerce' },
  { value: 'outro', label: 'Outro' },
];

export const STORE_OPTIONS: SelectOption[] = [
  { value: '1', label: '1 loja ou unidade' },
  { value: '2_5', label: '2 a 5' },
  { value: '6_20', label: '6 a 20' },
  { value: '20_mais', label: 'Mais de 20' },
];

export const SKU_OPTIONS: SelectOption[] = [
  { value: 'ate_100', label: 'Menos de 100' },
  { value: '100_1000', label: '100 a 1.000' },
  { value: '1000_5000', label: '1.000 a 5.000' },
  { value: '5000_10000', label: '5.000 a 10.000' },
  { value: '10000_mais', label: 'Mais de 10.000' },
];

export const SALES_HISTORY_OPTIONS: SelectOption[] = [
  { value: 'ate_12', label: 'Menos de 12 meses' },
  { value: '12_24', label: '12 a 24 meses' },
  { value: '24_mais', label: 'Mais de 24 meses' },
];

export const STOCK_CONTROL_OPTIONS: SelectOption[] = [
  { value: 'erp', label: 'ERP' },
  { value: 'planilha', label: 'Planilha / Excel' },
  { value: 'sistema_proprio', label: 'Sistema próprio' },
  { value: 'nenhum', label: 'Não há controle digital' },
];

export const EMPTY_DEMAND_FORM: DemandFormData = {
  full_name: '',
  email: '',
  company: '',
  phone: '',
  segment: '',
  stores: '',
  skus: '',
  sales_history: '',
  stock_control: '',
  difficulty: '',
  consent_accepted: false,
};
